import { filterProps } from './utils';
import { FormatError } from 'intl-messageformat';
import { IntlError } from './error';
var DISPLAY_NAMES_OPTONS = ['localeMatcher', 'style', 'type', 'fallback'];
export function formatDisplayName(_a, getDisplayNames, value, options) {
  var locale = _a.locale,
      onError = _a.onError;
  var DisplayNames = Intl.DisplayNames;

  if (!DisplayNames) {
    onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", "MISSING_INTL_API"
    /* MISSING_INTL_API */
    ));
  }

  var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);

  try {
    return getDisplayNames(locale, filteredOptions).of(value);
  } catch (e) {
    onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting display name.', e));
  }
}